// Copyright (c) StrangeBee 2024

export const classList = (...classElement: any[]): string => {
    const arrClass = classElement.reduce((acc, current) => {
        if (typeof current === 'object') {
            if (!Array.isArray(current)) {
                current = Object.entries(current).reduce((acc, [key, value]): any[] => {
                    return value ? [...acc, key] : acc;
                }, [] as any[]);
            }
            current = classList(...current);
        }

        return current ? [...acc, current] : acc;
    }, []);

    return arrClass.filter((e: any, i: number) => arrClass.indexOf(e) === i).join(' ');
};
